import { assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { assert_field_consumer } from '@shared/asserts/utils_assserts_graph';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__base } from '../graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__int } from '../graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { DTO_REQUEST__generation_create } from './DTO_REQUEST__generation_create';

export class DTO_REQUEST__generation_create_for_field_consumer extends DTO_REQUEST__generation_create {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_GENERATION_CREATE_FOR_FIELD_CONSUMER;

  /*
   * FIELDS
   */
  field_consumer!: FIELD__base;

  /*
   * METHODS
   */

  constructor() {
    super();

    this.field_consumer = FIELD_PRIMITIVE__int.CREATE_STUB();
  }

  assert_standard_fields() {
    super.assert_standard_fields();

    let { field_consumer, generation_id_previous: generation_id_consumer } = this;

    assert_string_object_id_not_empty(generation_id_consumer);

    if (!field_consumer.is_stub()) assert_field_consumer(field_consumer, generation_id_consumer);
  }
}
